import { jsx as v } from "@emotion/react/jsx-runtime";
import { createContext as E, useContext as c, useMemo as b } from "react";
const s = "__NOT_APPLICABLE__", G = () => s, H = (r) => r.target.value, i = (r, e, n, o, a) => n ? (t, ...u) => {
  const d = a ? a(t) : s;
  return o(r, e, d, t), n(t, ...u);
} : (t) => {
  const u = a ? a(t) : s;
  o(r, e, u, t);
}, _ = (r, e, n, o, a) => n.reduce(
  (t, u) => (t[u] = i(e, u, o[u], r, a), t),
  {}
), g = () => {
}, l = E({
  baseEventHandler: g
}), I = (r) => {
  const { handler: e, children: n } = r, o = {
    baseEventHandler: e
  };
  return /* @__PURE__ */ v(l.Provider, { value: o, children: n });
}, P = () => c(l), f = (r, e, n, o) => {
  const { baseEventHandler: a } = c(l), t = b(() => _(a, r, e, n, o), [r, e, n, o]);
  return {
    ...n,
    ...t
  };
};
export {
  l as G,
  H as I,
  G as N,
  I as a,
  P as b,
  f as u
};
